import Masonry from "masonry-layout";
import { SearchFilterEventEventData } from "./search-events";

//Adds the current protocol & domain to the additional text and returns the result
function AddRouteToRoot(route: string): string {
    let urlRoot: string = location.protocol + '//' + location.host;

    if (urlRoot) {
        return urlRoot + route;
    }

    return "";
}

function RenderItems(container: HTMLElement, itemList: HTMLElement[], itemsToShow: number) {
    const itemsToRender = itemList.slice(0, itemsToShow);

    itemsToRender.forEach((item: HTMLElement) => {
        const gridItem = document.createElement('div');
        gridItem.classList.add('grid-item');
        gridItem.appendChild(item);
        container.appendChild(gridItem);
    });
}

function RenderMasonryGrid(masonry: Masonry, itemsToShow: number, totalResults: number, showMore?: HTMLElement, cb?: () => void) {
    masonry.layout();
    if (cb) cb();
    if (showMore) (itemsToShow < totalResults) && showMore.classList.remove('d-none');

}

function ApplyFlexibleGrid(gridContainer: HTMLElement, itemList: HTMLElement[]) {
    if (gridContainer) {

        const itemWidth3Rows = `calc(33.3333% - 1rem)`;
        const itemWidth2Rows = `calc(50% - 0.5rem)`;

        const breakpoints = [
            { width: 1500, items: 3, generate: itemWidth3Rows },
            { width: 1200, items: 3, generate: itemWidth3Rows },
            { width: 768, items: itemList.length > 2 ? 2 : 0, generate: itemList.length > 2 ? itemWidth2Rows : null },
        ];

        let applied = false;

        // Generate custom grid layout where items are stacked without whitespace
        const generateFlexContainer = (columns: number, itemWidth: string) => {
            // Create columns
            for (let i = 0; i < columns; i++) {
                const flexContainer = document.createElement('div');
                flexContainer.classList.add('flex-col');
                flexContainer.style.width = itemWidth;

                // Create rows inside each column
                for (let j = 0; j < itemList.length; j += columns) {
                    const itemIndex = i + j;
                    const item = itemList[itemIndex];
                    if (item) {
                        const stackedItem = document.createElement('div');
                        stackedItem.classList.add('stacked-item');
                        stackedItem.appendChild(item);
                        flexContainer.appendChild(stackedItem);
                    }
                }
                gridContainer.appendChild(flexContainer);
            }
        };

        for (const breakpoint of breakpoints) {
            if (window.innerWidth >= breakpoint.width && !applied) {
                applied = true;
                if (breakpoint.items > 0) {
                    generateFlexContainer(breakpoint.items, breakpoint.generate);
                } else {
                    itemList.forEach(item => gridContainer.appendChild(item));
                }
            }
        }
        if (!applied) {
            itemList.forEach(item => gridContainer.appendChild(item));
        }
    }
}
function UpdateOffcanvasScrollBehavior(offcanvasElement: HTMLElement) {
    if (offcanvasElement) {

        if (window.innerWidth < 768) { // Adjust the breakpoint as needed
            offcanvasElement.setAttribute('data-bs-scroll', 'false');
        } else {
            offcanvasElement.setAttribute('data-bs-scroll', 'true');
        }
    }
}
function UpdateItemNumbersPerBreakPoint(windowWidth: number, isFilterToggled: boolean, TotalNumberOfResults: number): { itemsToShow: number; columns: number; maximumPages: number } {
    let itemsToShow = 0;
    let columns = 0;

    if (windowWidth >= 2160) {
        itemsToShow = !isFilterToggled ? 25 : 20;
        columns = !isFilterToggled ? 5 : 4;
    } else if (windowWidth >= 1200) {
        itemsToShow = 20;
        columns = 4;
    } else if (windowWidth >= 768) {
        itemsToShow = 15;
        columns = 3;
    } else {
        itemsToShow = 10;
        columns = 2;
    }

    const maximumPages = Math.ceil(TotalNumberOfResults / itemsToShow);

    return { itemsToShow, columns, maximumPages };
}
function UpdatePaginationButtons(page: number, isLastPage: boolean, maximumPages: number, paginationContainer: HTMLElement) {
    const paginationPrev = paginationContainer.querySelector(".pagination__prev button") as HTMLButtonElement;
    const paginationNext = paginationContainer.querySelector(".pagination__next button") as HTMLButtonElement;
    const paginationButtonWrapper = paginationContainer.querySelector(".pagination__buttons") as HTMLDivElement;
    const currentPageIndex = page;
    const isFirstPage = currentPageIndex <= 1;
    isLastPage = currentPageIndex === maximumPages || maximumPages <= 1;
    let paginationHTML = '';
    paginationPrev.setAttribute("aria-label", "previous page");
    paginationNext.setAttribute("aria-label", "next page");
    paginationPrev.ariaDisabled = isFirstPage ? "true" : "false";
    paginationNext.ariaDisabled = isLastPage ? "true" : "false";
    paginationPrev.disabled = isFirstPage;
    paginationNext.disabled = isLastPage;
    paginationPrev.classList.toggle("disabled", isFirstPage);
    paginationNext.classList.toggle("disabled", isLastPage);

    const ellipsisThreshold = 3;
    const totalPages = maximumPages;
    const currentPage = page;

    if (totalPages <= 1) {
        // Display all pages if there are not many
        for (let i = 1; i <= totalPages; i++) {
            paginationHTML += `<button type="button" class="pagination__button" data-page="${i}">${i}</button>`;
        }
    } else {
        for (let i = 1; i <= totalPages; i++) {

            if (i == totalPages || i == 1) { 
                paginationHTML += `<button type="button" class="pagination__button" data-page="${i}">${i}</button>`;
            } else {
                if (currentPage <= ellipsisThreshold) {
                    if (i <= ellipsisThreshold + 1) {
                        paginationHTML += `<button type="button" class="pagination__button" data-page="${i}">${i}</button>`;
                    } else if (i == ellipsisThreshold + 2) {
                        paginationHTML += `<span class="pagination__more">...</span>`;
                    }
                } else if (currentPage >= totalPages - ellipsisThreshold + 1) {
                    if (i >= totalPages - ellipsisThreshold) {
                        paginationHTML += `<button type="button" class="pagination__button" data-page="${i}">${i}</button>`;
                    } else if (i == totalPages - ellipsisThreshold - 1) {
                        paginationHTML += `<span class="pagination__more">...</span>`;
                    }
                } else {
                    if (i == currentPage - 1 || i == currentPage + 1 || i == currentPage) {
                        paginationHTML += `<button type="button" class="pagination__button" data-page="${i}">${i}</button>`;
                    } else if (i == currentPage - 2 || i == currentPage + 2) {
                        paginationHTML += `<span class="pagination__more">...</span>`;

                    }
                }
            }
        }
    }

    paginationButtonWrapper.innerHTML = paginationHTML;
    const paginationButtons = document.querySelectorAll('.pagination__button');
    paginationButtons.forEach(button => {
        const pageNumber = button.getAttribute("data-page");
        button.setAttribute("aria-label", `go to page ${pageNumber}`);
        if (button.classList.contains('is-active')) {
            button.classList.remove('is-active');
        }
        if (page === parseInt(button?.getAttribute("data-page"))) {
            button.classList.add('is-active');
        }
        button.addEventListener("click", (e) => {
            e.preventDefault();
            page = parseInt(button?.getAttribute("data-page"));
        })
    })

    if (maximumPages <= 1) {
        paginationContainer.style.display = 'none';
    } else {
        paginationContainer.style.display = '';
    }


}
function CheckExistingFilters(filters: SearchFilterEventEventData[], filterEventData?: SearchFilterEventEventData) {
    if (filters != null) {
        const searchKey: string = filterEventData.searchKey;
        const searchValue: string = filterEventData.searchValue;

        //Check for existing key in the filters array
        if (searchKey != null && searchValue != null) {
            let existingFilter: SearchFilterEventEventData = null;

            filters.forEach(filter => {
                if (filter.searchKey == searchKey) {
                    //Existing key
                    existingFilter = filter;
                }
            });

            //Update filter
            if (existingFilter != null) {
                existingFilter.searchValue = searchValue;
            } else {
                //Filter doesn't exist - Create one
                const newFilter: SearchFilterEventEventData = {
                    searchKey: searchKey,
                    searchValue: searchValue
                };
                filters.push(newFilter);
            }
        }
    }
}
function AddSearchAutocomplete(dropdownListItems: HTMLElement[], input: HTMLInputElement) {

    // Narrow down items as user types
    const searchText = input.value.toLowerCase();
    if (searchText === "") {
        dropdownListItems.forEach(item => {
            const data = item.getAttribute('data-name');
            item.innerHTML = data;
            item.classList.remove("d-none");
            item.classList.add("show");
        })
    }
    dropdownListItems.forEach(item => {
        const data = item.getAttribute('data-name');
        const dataLowerCase = data.toLowerCase();
        if (dataLowerCase.includes(searchText)) {
            const regex = new RegExp(`(${searchText})`, 'gi');
            item.innerHTML = data.replace(regex, '<b>$1</b>');
            item.classList.remove("d-none");
            item.classList.add("show");
        } else {
            item.classList.add("d-none");
            item.classList.remove("show");
        }
    });
}
function RenderTagList(tags?: string[]) {
    let innerHTML = '';
    if (tags) {
        tags.map(tag => {
            if (tag != "") {
                innerHTML += `<div class="card__tag">${tag.replace("\"", "")}</div>`
            }
        })
        if (tags.length > 2) {
            innerHTML += `<div class="card__tag extra">+${tags.length - 2}</div>`
        }
    }
    return innerHTML;
}
function HighlightMatchLetters(query: string, itemTitle: string) {
    const escapedSearch = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedSearch, 'gi');
    return itemTitle.replace(regex, (match) => `<strong>${match}</strong>`);
}
export {
    AddRouteToRoot,
    ApplyFlexibleGrid,
    RenderMasonryGrid,
    RenderItems,
    UpdateOffcanvasScrollBehavior,
    UpdateItemNumbersPerBreakPoint,
    UpdatePaginationButtons,
    CheckExistingFilters,
    AddSearchAutocomplete,
    RenderTagList,
    HighlightMatchLetters,
}